document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".script-container");

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("animate");
      }
    });
  }, { threshold: 0.1 });

  sections.forEach(section => observer.observe(section));
});

document.addEventListener("DOMContentLoaded", function () {

  const macroSection = document.querySelectorAll(".featured-macros");

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("animate");
      }
    });
  }, { threshold: 0.1 });

  macroSection.forEach(sec => observer.observe(sec));
});